import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import {PushDown} from '../pushdown/pusdown';
import { GlobalsVariables } from '../global-Variables';
import { TweenLite, Power2 } from 'gsap';
import * as $ from 'jquery';

@Component({
  selector: 'app-startseite',
  templateUrl: './startseite.component.html',
  styleUrls: ['./startseite.component.scss']
})
export class StartseiteComponent implements OnInit {

  constructor( public meta: Meta, public title: Title, private globalVari: GlobalsVariables ) {
    const site = 'startseite';
    this.meta.updateTag({ name: 'description', content: globalVari.meta[site].description });
    this.title.setTitle('Chris Wehrmann - ' + globalVari.meta[site].title );
  }

  ngOnInit() {
  }

  mouseEnter(divId: any) {
    const src = $( '#' + divId).attr('src');
    const sp = src.split('.p');
    $( '#' + divId).attr('src', sp[0] + '_h.p' + sp[1] );
  }
  mouseLeave(divId: any) {
    const src = $( '#' + divId).attr('src');
    const sp = src.split('_h.');
    $( '#' + divId).attr('src', sp[0] + '.' + sp[1] );
  }

}

